import { faceFactsConfig } from '@labrain/engine-staircase';
export const staircaseConfig = {
    ...faceFactsConfig,
    maxTrials: 16,
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, encodingMsPerFace: 3000, nCandidates: 3, showJob: false, label: 'Encodage holistique' };
    }
    if (level <= 20) {
        return { level, encodingMsPerFace: 2000, nCandidates: 4, showJob: false, label: 'Capacity + binding' };
    }
    if (level <= 30) {
        return { level, encodingMsPerFace: 1500, nCandidates: 4, showJob: true, label: 'Avec contexte' };
    }
    if (level <= 40) {
        return { level, encodingMsPerFace: 1000, nCandidates: 6, showJob: true, label: 'Encodage rapide' };
    }
    return { level, encodingMsPerFace: 800, nCandidates: 6, showJob: true, label: 'Cocktail mode' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
/** 12 "visages" emoji uniques pour MVP (Sprint 1+ : dataset diversifié). */
export const FACE_AVATARS = [
    '🧑‍🦰', '👩‍🦱', '🧑‍🦲', '👨‍🦳',
    '🧑‍🦳', '👩‍🦰', '👨‍🦱', '🧑',
    '👩', '👨', '🧓', '👵',
];
export const FACE_NAMES = [
    'Sophie', 'Léo', 'Anna', 'Pablo',
    'Inès', 'Mateo', 'Yuki', 'Adam',
    'Léna', 'Karim', 'Olga', 'Tarek',
    'Maya', 'Bruno', 'Élise', 'Théo',
];
export const FACE_JOBS = [
    'architecte', 'cuisinière', 'pilote', 'libraire',
    'médecin', 'menuisier', 'artiste', 'pompière',
    'ingénieure', 'fermier', 'graphiste', 'avocate',
];
export const timing = {
    preEncodingMs: 800,
    betweenEncodingMs: 300,
    preTestMs: 500,
    feedbackMs: 700,
    itiMs: 800,
};
export const paradigmMeta = {
    slug: 'face-facts',
    paradigm: 'Face memory (CFMT — Duchaine & Nakayama 2006)',
    masterMage: 'Sole (lumière) + Ondine (mémoire)',
    category: 'lumiere_emotions',
    goal: 'Mémoire visages-noms — relations pro, social, retenir client.',
};
//# sourceMappingURL=params.js.map